import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/SurveyStore';

const useSurvey = (surveyId: number) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(ActionCreators.GetSurvey(surveyId));
	}, [dispatch, surveyId]);

	return useSelector((state: IApplicationState) => state.survey);
};

export default useSurvey;
